<template>
    <svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.45 7.00015L1.1625 1.71265C0.987501 1.53765 0.900001 1.32515 0.900001 1.07515C0.900001 0.825148 0.987501 0.612648 1.1625 0.437648C1.3375 0.262648 1.55 0.175148 1.8 0.175148C2.05 0.175148 2.2625 0.262648 2.4375 0.437648L8.04375 6.0439C8.18125 6.1814 8.28125 6.3314 8.34375 6.4939C8.40625 6.6564 8.4375 6.82515 8.4375 7.00015C8.4375 7.17515 8.40625 7.3439 8.34375 7.5064C8.28125 7.6689 8.18125 7.8189 8.04375 7.9564L2.4375 13.5626C2.2625 13.7376 2.05 13.8251 1.8 13.8251C1.55 13.8251 1.3375 13.7376 1.1625 13.5626C0.9875 13.3876 0.9 13.1751 0.9 12.9251C0.9 12.6751 0.9875 12.4626 1.1625 12.2876L6.45 7.00015Z"
            :fill="fill" />
    </svg>
</template>

<script>
export default {
    props: {
        fill: {
            type: String,
            default: "#2F3941"
        }
    }
};
</script>